import React, { useEffect, useState } from 'react';
import { getAuth, verifyPasswordResetCode, confirmPasswordReset } from 'firebase/auth';

export default function ResetPassword() {
  const auth = getAuth();
  const [oobCode, setOobCode] = useState('');
  const [email, setEmail] = useState('');
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('oobCode') || '';
    setOobCode(code);
    if (!code) {
      setError('Invalid or missing reset code');
      return;
    }
    (async () => {
      try {
        const associatedEmail = await verifyPasswordResetCode(auth, code);
        setEmail(associatedEmail);
        setVerified(true);
      } catch (e) {
        setError('This reset link is invalid or expired. Please request a new one.');
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!password || password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    try {
      setSubmitting(true);
      await confirmPasswordReset(auth, oobCode, password);
      window.location.href = '/login?reset=success';
    } catch (e) {
      setError('Failed to reset password. Please request a new link.');
      setSubmitting(false);
    }
  };

  const Container = ({ children }) => (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #0b1020 0%, #0f172a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24
    }}>{children}</div>
  );

  return (
    <Container>
      <div style={{
        width: '100%',
        maxWidth: 440,
        background: 'rgba(17, 24, 39, 0.7)',
        border: '1px solid rgba(99, 102, 241, 0.2)',
        borderRadius: 16,
        padding: 28,
        color: '#fff',
        boxShadow: '0 10px 30px rgba(0,0,0,0.35)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <img src="/logo192.png" alt="Fidora" style={{ height: 44 }} />
        </div>
        <h1 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700 }}>Reset your password</h1>
        <p style={{ margin: '0 0 16px', color: '#cbd5e1', fontSize: 14 }}>
          {verified ? (
            <>For account <strong>{email}</strong></>
          ) : (
            'Verifying your link…'
          )}
        </p>
        {error && (
          <div style={{
            background: 'rgba(239,68,68,0.12)',
            border: '1px solid rgba(239,68,68,0.35)',
            color: '#fecaca',
            padding: '10px 12px',
            borderRadius: 8,
            marginBottom: 12,
            fontSize: 14
          }}>{error}</div>
        )}
        {verified && (
          <form onSubmit={handleSubmit}>
            <label style={{ display: 'block', fontSize: 13, marginBottom: 6, color: '#cbd5e1' }}>New password</label>
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)}
              style={{ width:'100%', padding:'12px 14px', borderRadius:8, border:'1px solid rgba(148,163,184,0.25)', background:'#0b1020', color:'#fff', marginBottom:12 }} />
            <label style={{ display: 'block', fontSize: 13, marginBottom: 6, color: '#cbd5e1' }}>Confirm password</label>
            <input type="password" value={confirm} onChange={(e)=>setConfirm(e.target.value)}
              style={{ width:'100%', padding:'12px 14px', borderRadius:8, border:'1px solid rgba(148,163,184,0.25)', background:'#0b1020', color:'#fff', marginBottom:16 }} />
            <button type="submit" disabled={submitting}
              style={{ width:'100%', padding:'12px 16px', borderRadius:8, border:'none', background:'#6366f1', color:'#fff', fontWeight:700, cursor: submitting?'wait':'pointer' }}>
              {submitting ? 'Saving…' : 'Set new password'}
            </button>
          </form>
        )}
      </div>
    </Container>
  );
}


